import { IScriptBase } from '../../interfaces/script/script-base';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a ScriptBlock task — executes a custom JavaScript function
 * against the full records array. The script receives (services, records, error)
 * and must return the modified records array. scriptJSBase64 is what gets executed;
 * scriptTSBase64 is the TypeScript source stored for Studio display only.
 */
export class ScriptBlockConfig extends DestinationTaskConfigBase implements IScriptBase {
	/**
	 * Base64-encoded TypeScript source. Used by iHub Studio for display and editing.
	 * Not executed at runtime — only scriptJSBase64 is run.
	 * @default ''
	 */
	scriptTSBase64 = '';

	/**
	 * Base64-encoded compiled JavaScript function expression. This is the field
	 * the service executes. Must be a single async function expression with signature:
	 * `async (services, records, error) => records`.
	 * @default ''
	 */
	scriptJSBase64 = '';

	constructor(init?: Partial<ScriptBlockConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
